import { isSampleLocalMode } from '../services/systems/sample-local/sampleLocalMode';

/** サンプルの更新・削除・使用記録登録権（所有者、または全件表示 ON の管理者） */
export function canManageSample(
  sample: { userId?: number },
  currentUserId?: number | null,
  options?: { isAdmin?: boolean; adminViewAll?: boolean }
): boolean {
  // Zip ローカル正本: セッション内データはすべて操作可（ログインユーザー ID は無い）
  if (isSampleLocalMode()) return true;
  if (currentUserId == null || sample.userId == null) return false;
  if (sample.userId === currentUserId) return true;
  return !!options?.isAdmin && options.adminViewAll === true;
}

/** 保管庫の更新・削除権（所有者、または全件表示 ON の管理者） */
export function canManageStorageRoom(
  room: { userId?: number | null; user?: { id: number } | null },
  currentUserId?: number | null,
  options?: { isAdmin?: boolean; adminViewAll?: boolean }
): boolean {
  if (isSampleLocalMode()) return true;
  const ownerId = room.user?.id ?? room.userId ?? null;
  if (currentUserId == null || ownerId == null) return false;
  if (ownerId === currentUserId) return true;
  return !!options?.isAdmin && options.adminViewAll === true;
}
